import { FilterRepositoryImpl } from "../data/FilterRepositoryImpl";
import { IFilterRepository } from "../domain/repository/IFilterRepository";
import { FilterUseCase } from "../domain/useCase/FilterUseCase";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class FilterInjection extends InjectionModule {
  private static readonly filterRepositoryToken = Symbol("IFilterRepository");
  private static readonly filterUseCaseToken = Symbol("FilterUseCase");

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.filterRepositoryToken,
      useClass: FilterRepositoryImpl,
    },
    {
      scope: "otherRepo",
      token: this.filterUseCaseToken,
      useClass: FilterUseCase,
    },
  ];

  static getRepo(): IFilterRepository {
    return this.resolve(this.filterRepositoryToken);
  }

  static getUseCase(): FilterUseCase {
    return this.resolve(this.filterUseCaseToken);
  }
}
